import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import * as rmd from 'material-ui';
import _ from 'lodash';
import cx from 'classnames';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import { green700, grey200, red500 } from 'material-ui/styles/colors';
import ErrorIcon from 'material-ui/svg-icons/alert/error';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import Autorenew from 'material-ui/svg-icons/action/autorenew';
import { Link } from 'react-router';
import ContentAdd from 'material-ui/svg-icons/content/add';
import config from 'cfg';

import styled from 'styled-components';

import SMPostDialog from '../SMPostDialog';

import IconDownload from 'material-ui/svg-icons/file/file-download';
import IconShare from 'material-ui/svg-icons/social/share';

import EventIncidentsSMStream from '../streams/event/EventIncidentsSMStream';

class SportHomeSMBrowser extends React.Component {
    static defaultProps = {
        eventId: 46
    };

    constructor(props, context) {
        super(props, context);
        this.state = {
            templates: []
        };
        this.loadData();
    }

    componentDidMount = () => {};

    componentWillReceiveProps = nextProps => {
        if (nextProps.params.sport !== this.props.params.sport) {
            this.forceUpdate(() => {
                this.loadData();
            });
        }
    };

    static contextTypes = {
        user: PropTypes.object.isRequired
    };

    loadData = additionalStateParams => {
        var user = this.context.user;
        if (!user || !user.client) return null;
        var sportId = RCore.sportToId(this.props.params.sport);
        return RCore.promiseProps({
            tournaments: fetch(`${config.apis.ss2}/tournaments?sportId=${sportId}`)
                .then(response => response.json())
                .then(tournaments => {
                    return _.filter(tournaments, t => t.isEnabled);
                })
        }).then(res => {
            this.setState(res);
        });
    };

    render() {
        const user = this.context.user;
        let { tournaments } = this.state;

        return (
            <div className="row">
                <div className="col-md-12">
                    <h1>{this.props.params.sport} sport home</h1>
                </div>

                {_.chain(tournaments)
                    .groupBy(t => t.countryName)
                    .map((tournaments, country) => {
                        return (
                            <div key={country}>
                                <h1 className="col-md-12">{country}</h1>
                                {tournaments.map(t => {
                                    return (
                                        <div className="col-md-2" key={t.key}>
                                            <Link to={`/sm/browser/${this.props.params.sport}/tournaments/${t.id}`}>
                                                {t.name}
                                            </Link>
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })
                    .value()}
            </div>
        );
    }
}

export default SportHomeSMBrowser;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/SportHomeSMBrowser.js
 **/